import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { styled, useTheme } from '../../styles';
import { Column } from '../layout';
import { Avatar } from './avatar';
const Container = styled(Column)(({ size }) => ({
    position: 'relative',
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
    height: size,
    width: size,
    borderRadius: size / 2,
}));
export const AvatarPreview = ({ size, src, name, ...props }) => {
    const theme = useTheme();
    const [hovered, setHovered] = useState(false);
    return (_jsxs(Container, { onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false), size: size, children: [_jsx(Avatar, { src: src, displayName: name, size: "xlarge" }), hovered && (_jsx(Column, { position: "absolute", top: 0, left: 0, right: 0, bottom: 0, bg: theme.colors.hoverBlue, opacity: 0.9, justifyContent: "center", alignItems: "center", children: props.children }))] }));
};
//# sourceMappingURL=avatar_preview.js.map